import { designs, techs } from "../const/data";
import TransitionText from "../components/TransitionText";
import FindBug from "../assets/icons/FindBug";
import Browser from "../assets/icons/Browser";
import { dict } from "../const/dict";

const Skills = () => {
  return (
    <div className="section page-container">
      <div className=" flex-col justify-start">
        <TransitionText text={dict.skillsAndExperience} wrapperClassName="justify-center" />
        <p className="text-description mt-2 xl:mt-5 text-center">
          {dict.about1}
          <br />
          {dict.about2}
          <br />
          {dict.about3}
          <br />
          {dict.about4}
        </p>
        <div className="flex-col justify-center items-center gap-5 mt-10 hidden xl:flex">
          <div className="flex flex-wrap gap-5 h-16">
            {techs.map((item) => (
              <img
                src={require(`../assets/images/techs/${item}.png`)}
                className={`icon-transition w-16 ${item === "js" ? "rounded-md" : ""}`}
                alt={item}
              />
            ))}
          </div>
          <div className="flex gap-5 h-16 flex-wrap justify-center">
            {designs.map((item) => (
              <img
                src={require(`../assets/images/techs/${item}.png`)}
                className="icon-transition w-16"
                alt={item}
              />
            ))}
          </div>
        </div>
        <div className="flex flex-wrap gap-2 mt-4 xl:hidden justify-center items-center">
          {[...techs, ...designs].map((item) => (
            <img
              src={require(`../assets/images/techs/${item}.png`)}
              className={`icon-transition w-8 h-8 ${item === "js" ? "rounded-md" : ""}`}
              alt={item}
            />
          ))}
        </div>
      </div>
      <FindBug className="absolute left-12 top-44 blur-[6px]" />
      <Browser className="absolute -right-16 -bottom-56 blur-[6px] w-[200px] xl:w-[300px]" />
    </div>
  );
};

export default Skills;
